module.exports = __webpack_public_path__ + "static/media/close-team.9eb15e17.svg";